import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { api } from '../api';
import { toast } from 'react-toastify';

function Refunds() {
  const [refunds, setRefunds] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalRefunds, setTotalRefunds] = useState(0);
  const [noOfPages, setNoOfPages] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRefunds();
  }, [page, limit]);

  async function fetchRefunds() {
    setLoading(true);
    try {
      const { refunds: fetchedRefunds, total, noOfPages: pages } = await api.getRefunds(page, limit);
      setRefunds(fetchedRefunds.map(refund => ({
        id: refund.id,
        orderId: refund.order?.id || 'N/A',
        customerName: refund.user?.fullName || 'N/A',
        amount: refund.amount,
        status: refund.status,
        paymentIntentId: refund.paymentIntentId,
        createdAt: new Date(refund.createdAt).toLocaleString(),
        updatedAt: new Date(refund.updatedAt).toLocaleString(),
      })));
      setTotalRefunds(total);
      setNoOfPages(pages);
    } catch (error) {
      console.error("Error fetching refunds:", error);
      toast.error("Failed to load refunds.");
    }
    setLoading(false);
  }

  return (
    <>
      <Helmet><title>Refunds | Owena Admin Dashboard</title></Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>Refund Requests</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={(e)=>e.preventDefault()}>Home</a></span><span><i className="mdi mdi-chevron-right"></i></span>Refunds</p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card card-default">
                <div className="card-header">
                  <h2>Refunds Listing</h2>
                </div>
                <div className="card-body">
                  {loading ? (<p>Loading refunds...</p>) : refunds.length === 0 ? (<p>No refunds found.</p>) : (
                  <div className="table-responsive">
                      <table className="table table-hover ec-table">
                      <thead>
                        <tr>
                            <th>ID</th>
                          <th>Order ID</th>
                          <th>Customer</th>
                          <th>Amount</th>
                          <th>Status</th>
                            <th>Created At</th>
                            <th>Updated At</th>
                        </tr>
                      </thead>
                      <tbody>
                          {refunds.map((refund) => (
                            <tr key={refund.id}>
                              <td>{refund.id}</td>
                              <td>{refund.orderId}</td>
                              <td>{refund.customerName}</td>
                              <td>{refund.amount}</td>
                              <td>{refund.status}</td>
                              <td>{refund.createdAt}</td>
                              <td>{refund.updatedAt}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  )}

                  {noOfPages > 1 && (
                    <nav className="mt-3">
                      <ul className="pagination justify-content-center">
                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}><a className="page-link" href="#" onClick={(e) => { e.preventDefault(); setPage(prev => Math.max(1, prev - 1)); }}>Previous</a></li>
                        {[...Array(noOfPages)].map((_, idx) => (
                          <li key={idx + 1} className={`page-item ${page === idx + 1 ? 'active' : ''}`}><a className="page-link" href="#" onClick={(e) => { e.preventDefault(); setPage(idx + 1); }}>{idx + 1}</a></li>
                        ))}
                        <li className={`page-item ${page === noOfPages ? 'disabled' : ''}`}><a className="page-link" href="#" onClick={(e) => { e.preventDefault(); setPage(prev => Math.min(noOfPages, prev + 1)); }}>Next</a></li>
                      </ul>
                    </nav>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Refunds;
